module.exports = __webpack_public_path__ + "img/svmic-logo.e59f13b8.png";